// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2rvP9","sendOtp":"AuthorizeToLogin_sendOtp__2vCkU"};